import React from 'react';
import { withStyles } from 'material-ui/styles';
import { TableCell } from 'material-ui/Table';
import headerStyle from './headerStyle';

// Here ActioAlign is boolian used to center align only Action header of user grid (manage user grid)
const HeaderCell = ({ classes, label, actionAlign }) => <TableCell className={actionAlign ? classes.headAction : classes.head}>{label}</TableCell>;

export default withStyles(headerStyle)(HeaderCell);
